import { useEffect, useRef, useState } from "react";
import useAxios from "../../utils/useAxios";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

function Gallery() {
  const [media, setMedia] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [noDataFound, setNoDataFound] = useState(false); // Initially false (i.e., assume data is available)
  const [notFoundMessage, setNotFoundMessage] = useState("");
  const [leads, setLeads] = useState([]);
  const axiosAPI = useAxios();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [formData, setFormData] = useState({
    mediaName: "",
    mediaType: "",
    mediaUrl: "",
    thumbnailUrl: "",
  });
  const [uploadedFile, setUploadedFile] = useState(null); // for file input
  const fileRef = useRef(null);

  const removeFormData = () => {
    setFormData({
      mediaName: "",
      mediaType: "",
      mediaUrl: "",
      thumbnailUrl: "",
    });
    fileRef.current.value = null;
  };

  const [filters, setFilters] = useState({
    status: "",
    from_date: "",
    to_date: "",
  });

  // Handler to update filters
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Get All Notifications
  const getMedia = async () => {
    try {
      const response = await axiosAPI.get(`/api/media/get-media?page=${page}`);
      // console.log(response.data.data);
      setMedia(response.data.data);
      setTotalPages(response?.data?.totalPages);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  // console.log(statusList);

  useEffect(() => {
    getMedia();
  }, [page]);

  // Handle Input Changes
  const handleChange = (e) => {
    const { id, value, files, type } = e.target;

    if (type === "file") {
      setUploadedFile(files[0]); //  store separately
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      let response;

      // Use FormData to handle file uploads + other fields
      const formPayload = new FormData();
      formPayload.append("media_name", formData.mediaName);
      formPayload.append("media_type", formData.mediaType);
      formPayload.append("media_url", formData.mediaUrl); // text URL
      formPayload.append("thumbnail_url", formData.thumbnailUrl); // text URL

      if (uploadedFile) {
        formPayload.append("file", uploadedFile); // attach file if available
      }

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/media/${currentUserId}`,
          formPayload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        window.notifyMessage(
          "Success",
          "Media updated successfully",
          "success"
        );
      } else {
        response = await axiosAPI.post("/api/media/add-media", formPayload, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        window.notifyMessage("Success", "Media added successfully", "success");
      }

      hideModal("newGalleryModal");
      getMedia();
      removeFormData();
      setIsEditMode(false);
      setIsLoading(false);
      closeModal();
    } catch (error) {
      setIsLoading(false);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);
    // console.log(id);

    // Find the notification with this ID and populate the form
    const selectedMedia = media.find((media) => media.id === id);
    console.log("Open edit modal", selectedMedia);
    if (selectedMedia) {
      setFormData({
        mediaName: selectedMedia.media_name,
        mediaType: selectedMedia.media_type,
        mediaUrl: selectedMedia.media_url,
        thumbnailUrl: selectedMedia.thumbnail_url,
      });
    }
    // console.log(selectedMedia)
    showModal("newGalleryModal");
  };

  const handleDelete = async (id) => {
    console.log(id);
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/media/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      getMedia();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newGalleryModal");
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Gallery Item
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newGalleryModal"
          tabIndex="-1"
          aria-labelledby="newGalleryModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newGalleryModalLabel">
                  {isEditMode ? "Edit Gallery" : "Add Gallery"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Media Name (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="mediaName" className="form-label">
                      Media Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="mediaName"
                      placeholder="Enter media name"
                      value={formData.mediaName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="mediaUrl" className="form-label">
                      Media Url
                    </label>
                    <textarea
                      className="form-control"
                      id="mediaUrl"
                      placeholder="Enter your media URL"
                      value={formData.mediaUrl}
                      onChange={handleChange}
                      rows={3}
                      required
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="thumbnailUrl" className="form-label">
                      Thumbnail Url
                    </label>
                    <textarea
                      className="form-control"
                      id="thumbnailUrl"
                      placeholder="Enter your thumbnail URL"
                      value={formData.thumbnailUrl}
                      onChange={handleChange}
                      rows={3}
                      required
                    ></textarea>
                  </div>

                  {/* Select Media  */}
                  <div className="mb-3">
                    <label htmlFor="mediaType" className="form-label">
                      Select Media Type
                    </label>
                    <select
                      className="form-select"
                      id="mediaType"
                      name="mediaType"
                      required
                      value={formData.mediaType}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Media Type
                      </option>

                      <option value="image">Image</option>
                      <option value="video">Video</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="mediaFile" className="form-label">
                      Upload (Image or Video)
                    </label>
                    <input
                      type="file"
                      ref={fileRef}
                      className="form-control"
                      id="mediaFile" // changed from mediaFile to avoid conflict
                      name="mediaFile"
                      accept="image/*,video/*"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                    disabled={isLoading} // Disable button while isLoading
                  >
                    {isLoading ? (
                      <FaSpinner className="spinner" spin /> // Loader icon from react-icons
                    ) : isEditMode ? (
                      "Update Gallery"
                    ) : (
                      "Add Gallery"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Notification Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left Section - User Details */}
                <div className="d-flex align-items-center">
                  <h4 className="card-title mb-0">
                    All Media ({media?.length} )
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Media Name</th>
                        <th>Media Url</th>
                        <th>Thumbnail Url</th>
                        <th>Media type</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Show a loading state when data is being fetched
                        <tr>
                          <td colSpan="9" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : media.length == 0 ? (
                        // Show a "No Data Found" message when no data is available
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        // Render the list of leads if data is available
                        media.map((media) => {
                          const formattedDate = new Date(
                            media.created_at
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          //   Check if the message length is greater than 50 characters and truncate it
                          const truncatedMessage =
                            media.media_url.length > 50
                              ? media.media_url.slice(0, 50) + "..."
                              : media.media_url;
                          const truncatedThumbnailMessage =
                            media.thumbnail_url?.length > 50
                              ? media.thumbnail_url.slice(0, 50) + "..."
                              : media.thumbnail_url;

                          return (
                            <tr key={media.id}>
                              <td>{media.media_name}</td>
                              <td>{truncatedMessage}</td>
                              <td>{truncatedThumbnailMessage}</td>
                              <td>{media.media_type}</td>
                              <td>{formattedDate}</td>
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(media.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(media.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
